export default __webpack_public_path__ + "static/media/list_icon.d1e66c33.svg";